(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eased-green-buybox"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eased-green-buybox')) {
  customElements.define('eased-green-buybox', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const form = this.querySelector('form');
      const owner = this.closest('eased-storefront');
      const submit = this.querySelector('.egb-atc');
      const sticky = owner?.querySelector('[data-sticky-buy]');
      const status = this.querySelector('[data-egb-status]');
      const copy = JSON.parse(this.querySelector('[data-egb-copy]').textContent);
      const unit = Number(this.dataset.unit);
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency}).format(amount / 100);
      const update = () => {
        const selected = this.querySelector('[data-egb-pack]:checked');
        const paid = Number(selected.dataset.paid);
        const quantity = Number(selected.value);
        const total = unit * paid;
        const original = Number(this.dataset.compareUnit) * quantity;
        const countLabel = quantity === 1 ? copy.onePack : copy.count.replace('__COUNT__',String(quantity));
        owner?.querySelectorAll('[data-sticky-price]').forEach(el => el.textContent = money(total));
        owner?.querySelectorAll('[data-sticky] [data-compare-price]').forEach(el => {el.textContent = money(original); el.hidden = original === total;});
        if (sticky) sticky.disabled = submit.disabled;
      };
      form.addEventListener('change', update, {signal});
      update();
      sticky?.addEventListener('click', () => form.requestSubmit(submit), {signal});
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submit.disabled) return;
        const selected = this.querySelector('[data-egb-pack]:checked');
        const line = {id: form.elements.id.value, quantity: Number(selected.value)};
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
        if (sticky) sticky.disabled = true;
        status.textContent = '';
        let added = false;
        try {
          const sections = [...new Set(['cart-drawer-section', ...Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), el => el.dataset.sectionId)])].slice(0,5);
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [line], sections, sections_url: window.location.pathname})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          added = true;
          const drawer = document.getElementById('cart-drawer');
          if (!drawer || !result.sections?.['cart-drawer-section']) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          const {CartLinesUpdateEvent} = await import('@shopify/events');
          const cartResponse = await fetch(this.dataset.cartUrl + '.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
          if (!cartResponse.ok) throw new Error(this.dataset.error);
          const cart = await cartResponse.json();
          this.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add', context: 'product',
            promise: Promise.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {sections: result.sections, items: cart.items, source: 'eased-green-buybox', didError: false}
            })
          }));
          await customElements.whenDefined('theme-drawer');
          drawer.open();
          status.textContent = this.dataset.added;
        } catch (error) {
          if (added) window.location.assign(this.dataset.cartUrl);
          else status.textContent = error.message || this.dataset.error;
        } finally {
          submit.disabled = false;
          submit.removeAttribute('aria-busy');
          if (sticky) sticky.disabled = false;
        }
      }, {signal});
    }
    disconnectedCallback() {this.controller?.abort(); this.initialized = false;}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eased-ingredients"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eased-ingredients')) {
  customElements.define('eased-ingredients', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const dialogs = Array.from(this.querySelectorAll('dialog'));
      const buttons = Array.from(this.querySelectorAll('[data-ingredient-open]'));
      let active = 0;
      const open = index => {
        const previous = dialogs[active];
        const next = (index + dialogs.length) % dialogs.length;
        if (previous.open) previous.close();
        active = next;
        dialogs[active].showModal();
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => open(index), {signal}));
      dialogs.forEach((dialog, index) => {
        dialog.querySelector('[data-ingredient-close]').addEventListener('click', () => dialog.close(), {signal});
        dialog.querySelectorAll('[data-ingredient-step]').forEach(button => button.addEventListener('click', () => open(index + Number(button.dataset.ingredientStep)), {signal}));
        dialog.addEventListener('click', event => {
          const box = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
        }, {signal});
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eased-product-reels"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('eased-product-reels')){
  customElements.define('eased-product-reels',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      const cards=[...this.querySelectorAll('.epr-card')];
      const videos=cards.map(card=>card.querySelector('video'));
      const progress=this.querySelector('.epr-progress span');
      if(progress)progress.style.width=100/cards.length+'%';
      cards.forEach((card,index)=>{
        const video=videos[index],button=card.querySelector('.epr-play');
        video.controls=false;
        button.hidden=false;
        button.addEventListener('click',()=>{
          video.controls=true;
          video.play().catch(()=>{video.controls=true;button.hidden=true;});
        },{signal});
        video.addEventListener('play',()=>{
          videos.forEach(other=>{if(other!==video)other.pause();});
          button.hidden=true;
          video.controls=true;
          if(progress)progress.style.transform='translateX('+index*100+'%)';
        },{signal});
        video.addEventListener('pause',()=>{button.hidden=false;video.controls=false;},{signal});
        video.addEventListener('ended',()=>{button.hidden=false;video.controls=false;},{signal});
      });
      this.observer=new IntersectionObserver(entries=>{
        if(!entries[0].isIntersecting)videos.forEach(video=>video.pause());
      },{threshold:0});
      this.observer.observe(this);
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eased-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eased-timeline')) {
  customElements.define('eased-timeline', class extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('.et-step')];
      this.markers = [...this.querySelectorAll('.et-marker')];
      this.track = this.querySelector('.et-track');
      this.fill = this.querySelector('.et-fill');
      if (!this.markers.length) return;
      this.controller = new AbortController();
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, { passive: true, capture: true, signal: this.controller.signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal: this.controller.signal });
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this);
      this.update();
    }
    update() {
      const boxes = this.markers.map(marker => marker.getBoundingClientRect());
      const first = boxes[0].top + boxes[0].height / 2;
      const last = boxes[boxes.length - 1].top + boxes[boxes.length - 1].height / 2;
      const distance = Math.max(1, last - first);
      const threshold = window.innerHeight * .65;
      this.track.style.top = `${first - this.getBoundingClientRect().top}px`;
      this.track.style.height = `${distance}px`;
      this.track.style.bottom = 'auto';
      this.fill.style.transform = `scaleY(${Math.min(1, Math.max(0, (threshold - first) / distance))})`;
      this.steps.forEach((step, i) => step.classList.toggle('is-reached', boxes[i].top + boxes[i].height / 2 <= threshold));
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
